import styled from 'styled-components';

interface GridProps {
  columns?: number;
  gap?: 'sm' | 'md' | 'lg';
}

export const Grid = styled.div<GridProps>`
  display: grid;
  grid-template-columns: repeat(${({ columns = 3 }) => columns}, minmax(300px, 1fr));
  gap: ${({ theme, gap = 'md' }) => theme.spacing[gap]};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
    gap: ${({ theme, gap = 'sm' }) => theme.spacing[gap]};
  }
`;

export const TwoColumnLayout = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xlg};
  align-items: flex-start;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
  }
`;
